<template>
  <div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="月份：">
        <el-date-picker v-model="inputDate" type="month" :default-value="new Date()" @change="changeDate"
          :clearable="false" value-format="yyyy-MM" placeholder="选择月" :editable="false" format="yyyy年MM月" size="small">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
          搜索
        </el-button>
      </el-form-item>
    </el-form>

    <div class="content">
      <span class="content_title">
        {{ this.title }}
      </span>
      <div class="tableData">
        <el-table :data="listTableData" style="width: 100%;" border stripe :highlight-selection-row="true"
          empty-text="暂无数据" v-loading="loading" row-key="storeKeyId" height="600px"
          :header-cell-style="{ backgroundColor: '#b3e0ff' }">
          <el-table-column label="序号" prop="rowNumber" width="60" fixed="left" align="center"></el-table-column>
          <el-table-column label="门店名称" prop="storeName" width="120" fixed="left" align="center"></el-table-column>
          <el-table-column label="订单本月完成数量" align="center">
            <el-table-column label="总订单量" align="center" width="90">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.finishedTotalCount) }}
              </template>
            </el-table-column>
            <el-table-column label="常规订单" align="center" width="90">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.normalTotalCount) }}
              </template>
            </el-table-column>
            <el-table-column label="售后订单" align="center" width="90">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.afterSaleTotalCount) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="订单状态统计" align="center">
            <el-table-column v-for="(item, index) in listStateColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="70" :key="'state-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listStates[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listStateColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="120" :key="'state-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listStates[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="订单总数" width="90" align="center">
            <template slot-scope="scope">
              {{ convertToZero(scope.row.totalCount) }}
            </template>
          </el-table-column>
          <el-table-column label="镜架数量" width="90" align="center">
            <template slot-scope="scope">
              {{ convertToZero(scope.row.orderLensCount) }}
            </template>
          </el-table-column>
          <el-table-column label="镜片数量" width="90" align="center">
            <template slot-scope="scope">
              {{ convertToZero(scope.row.orderEyeglassCount) }}
            </template>
          </el-table-column>
          <el-table-column label="加工类型" align="center">
            <el-table-column v-for="(item, index) in listMachinTypeColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="90" :key="'machine-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listMachinTypes[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listMachinTypeColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="120" :key="'machine-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listMachinTypes[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="加工渠道" align="center">
            <el-table-column v-for="(item, index) in listMachinChannelColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="90" :key="'machine-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listMachinChannels[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listMachinChannelColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="120" :key="'machine-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listMachinChannels[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="订单来源" align="center">
            <el-table-column v-for="(item, index) in listOrderSourceColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="90" :key="'source-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listOrderSource[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listOrderSourceColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="140" :key="'source-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listOrderSource[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="审核类型" align="center">
            <el-table-column v-for="(item, index) in listAuditTypeColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="90" :key="'audit-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listAuditType[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listAuditTypeColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="140" :key="'audit-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listAuditType[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="出库单状态" align="center">
            <el-table-column v-for="(item, index) in listOutputStateColumns" :label="item.value" align="center"
              v-if="item.value.length < 4" width="90" :key="'output-short-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listOutputState[index]) }}
              </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in listOutputStateColumns" :label="item.value" align="center"
              v-if="item.value.length >= 4" width="120" :key="'output-long-' + index">
              <template slot-scope="scope">
                {{ convertToZero(scope.row.listOutputState[index]) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="出库单数量" width="120" align="center" fixed="right">
            <template slot-scope="scope">
              {{ convertToZero(scope.row.totalOutputCount) }}
            </template>
          </el-table-column>
          <el-table-column label="出库总金额" width="120" align="center" fixed="right">
            <template slot-scope="scope">
              {{ convertToZero(scope.row.totalMoney) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { GetStoreOrderStatistic } from "@/api/storeOrderApi.js";
export default {
  data() {
    return {
      loading: false,
      inputDate: new Date(),
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      title: "",
      listStateColumns: [],
      listMachinTypeColumns: [],
      listOutputStateColumns: [],
      listTableData: [],
      listMachinChannelColumns: [],
      listOrderSourceColumns: [],
      listAuditTypeColumns: [],
    };
  },
  // 注册组件
  components: {},
  created() {
    this.getListData();
  },
  computed: {},
  methods: {
    changePages() { },
    // 获取列表
    getListData() {
      this.loading = true;
      this.title = this.formInline.year + "年" + this.formInline.month + "月门店加工订单数量统计"
      GetStoreOrderStatistic(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.listStateColumns = res.data.listStateColumns;
            this.listMachinTypeColumns = res.data.listMachinTypeColumns;
            this.listOutputStateColumns = res.data.listOutputStateColumns;
            this.listMachinChannelColumns = res.data.listMachinChannelColumns;
            this.listOrderSourceColumns = res.data.listOrderSourceColumns;
            this.listAuditTypeColumns = res.data.listAuditTypeColumns;
            this.listTableData = res.data.datas;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        }).finally(() => {
          this.loading = false;
        });
    },
    inputChange(val) {
      this.search();
    },
    // 搜索事件
    search() {
      this.getListData();
    },
    // 时间选择
    changeDate(val) {
      if (val) {
        this.formInline.year = parseInt(val.split("-")[0]);
        this.formInline.month = parseInt(val.split("-")[1]);
      }
      this.search();
    },
    // 转换为0的值
    convertToZero(value) {
      if (value === 0) {
        return '--';
      }
      return value;
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  border-radius: 10px;
  background: #fff;
  padding: 20px;
  min-height: 650px;
  text-align: center;
  margin-bottom: 20px;

  .content_title {
    font-size: 32px;
    font-weight: 700;
    display: block;
  }

  .tableData {
    width: 100%;
    display: flex;
    margin-top: 20px;
    height: 550px;

    table {
      border: 2px solid #000;
      border-radius: 5px;
      width: 100%;
    }

    table,
    th {
      height: 35px;
      font-family: "楷体";
      font-size: 18px;
      font-weight: 900;
      min-width: 80px;
      border: 1px solid #000;
    }

    table,
    td {
      border: 1px solid #000;
      padding: 0;
      margin: 0;
      text-align: center;
      border-collapse: collapse;
      font-size: 16px;
      font-family: "宋体";
      font-weight: 500;
    }

    .qiuJing {
      font-size: 18px;
      font-weight: 900;
      height: 35px;
      line-height: 35px;
      font-family: "楷体";
    }
  }

  .highlight-table {
    border-collapse: collapse;
    width: 100%;
  }

  .highlight-table th,
  .highlight-table td {
    border: 1px solid #ddd;
    // padding: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .highlight-row>td {
    background-color: #e6f7ff;
  }

  .highlight-col {
    background-color: #b3e0ff;
  }

  .highlight-cell {
    background-color: #1890ff;
    color: black;
    font-weight: bold;
  }
}

/* 全局边框颜色 */
.el-table--border,
.el-table--group {
  border-color: black;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid black;
}

.el-table--border td,
.el-table--border th {
  border-right: 1px solid black;
}

.el-table::before,
.el-table--group::after {
  background-color: #C6CAD6;
  /* 匹配边框颜色 */
}

.el-table {
  border-radius: 10px;
  border: 1px solid #DEDEDE;
  /* 四周边框 */
}
</style>